import React from "react";
import { namePathMain, namePathProducts, pathMain, pathProducts } from "../../common/config/paths";
import { TopPathWay } from "../../common/ui/TopPathWay";
import { ProductList } from "./organoids/ProductList";
import { useSeo } from "../../common/hooks/useSeo";
import "./styles/ForIndex.css";

export const Products = () => {
  const topWay = [
    {name: namePathMain, path: pathMain},
    {name: namePathProducts, path: pathProducts},
  ]
  
    

  useSeo({
    title: "Продукты и решения 1С — ООО АБС",
    description:
      "Программные продукты и готовые решения на базе 1С от компании «АБС» для эффективного управления бизнесом.",
    canonicalPath: pathProducts,
  })

  return (
    <>
      <div className="page_main_con" >
        <div style={{width: "100%", height: "100%", padding: "20px"}}>
          <TopPathWay list={topWay} />
          <h1 className="page_title_products gradient1">{namePathProducts}</h1>
          <ProductList/>          
        </div>
      </div>
    </>
  );
};




